// Addresses on the site look like normal pages (/drama/abc, /watch/abc/3), so each one can be opened, shared and indexed.
// This turns a click on an internal link into a page change without reloading, and keeps the back button working.
// `root` is where the pages of the language being shown start: the site's own address, or that with a language in front (/th/).
export function createRouter({ mount: root, routes, render }) {
  const mount = root;
  const strip = (pathname) => {
    const p = pathname.startsWith(mount) ? '/' + pathname.slice(mount.length) : pathname;
    return p.replace(/\/+$/, '') || '/';
  };

  function match(pathname) {
    const path = strip(pathname);
    for (const [pattern, name] of routes) {
      const m = pattern.exec(path);
      if (m) return { name, params: m.groups ?? {}, path };
    }
    return { name: 'notfound', params: {}, path };
  }

  function go(to, { replace = false } = {}) {
    const url = new URL(to, location.href);
    if (url.origin !== location.origin) return void (location.href = url.href);
    history[replace ? 'replaceState' : 'pushState']({}, '', url);
    render(match(url.pathname), url);
    window.scrollTo(0, 0);
  }

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || !url.pathname.startsWith(mount) || /^\/(_|v1\/)/.test('/' + url.pathname.slice(mount.length))) return;
    e.preventDefault();
    go(url.href);
  });
  window.addEventListener('popstate', () => render(match(location.pathname), new URL(location.href)));

  return { go, match, start: () => render(match(location.pathname), new URL(location.href)), href: (path) => mount.replace(/\/$/, '') + path };
}
